import fr from './fr/common.json';
import en from './en/common.json';

const translations = {
  fr,
  en
};

export default translations;